// test578
(578 && 0);
